import { createFileRoute } from '@tanstack/react-router'
import { WaRepairBudgetPanel } from '../../components/dev/WaRepairBudgetPanel'

export const Route = createFileRoute('/dev/wa-repair-budget')({
  component: WaRepairBudgetPanel,
})
